import { useQuery } from "@tanstack/react-query";
import { getSubcategorias } from "../../../api";

const useGetSubcategorias = (categoriasIds: number[], produtoId: number) => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["get_subcategorias", produtoId, categoriasIds],
    enabled: categoriasIds.length > 0, // S� habilita a consulta se houver categorias selecionadas
    queryFn: () => getSubcategorias(categoriasIds, produtoId),
    refetchOnWindowFocus: false,
  });

  return {
    data,
    isLoading,
    isError,
    error,
  };
};

export default useGetSubcategorias;
